import React, { useRef } from 'react';

import emailjs from 'emailjs-com';
import './Contact.css'

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('istigmail', 'template_03yytki', e.target, 'user_60r4aYSCQIaG3DYQ999oS')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };



    return (
        <div id='contact' className='contact-part'>
            <div className="row">
                <div className="container col-lg-12">
                    < small className='text-danger fs-4 fw-bold'>Contact</small >
                    <h2 className='section'>My Contact

                    </h2>
                </div>
            </div>

            <div className='contact-img'>

                <>
                    <form ref={form} onSubmit={sendEmail}>
                        <label className='text-light mb-2 ms-2'>Name</label>
                        <input className='ms-2 w-100' type="text" name="user_name" />
                        <br />
                        <label className='text-light mt-3 ms-2'>Email</label>
                        <input className='ms-2 w-100' type="email" name="user_email" />
                        <br />
                        <label className='text-light mt-5 ms-2'>Message</label>
                        <textarea className='ms-2 w-100' name="message" />
                        <br />
                        <input className='btn-danger send-button' type="submit" value="Send" />
                    </form>
                    );
};

                </>

            </div>

            <h6 className='text-center text-light mt-5'>Copyright all reserved Istiaque Ahmed</h6>



        </div>
    );
};

export default Contact;